import { Component } from '@angular/core';
import { I18n } from '@ngx-translate/i18n-polyfill';

@Component({
  selector: 'error-screen',
  templateUrl: './error-screen.component.html',
  styleUrls: ['./error-screen.component.scss']
})
export class ErrorScreenComponent {
  constructor(   
    private i18n: I18n,
  ) { }

  update(){
    location.reload();
  }
}
